module.exports = __webpack_public_path__ + "img/documents-illustration.32d8aea2.svg";